import { Component } from '@angular/core';

@Component({
  selector: 'lib-container-list-template',
  templateUrl: './container-list-template.component.html',
  styleUrls: ['./container-list-template.component.scss']
})
export class ContainerListTemplateComponent {}
